import React from 'react'

import type { UserGroupScopeItem } from './ModalUserGroupsAccess'
import { addSpacesToPascalCase } from '../../../../../services/helpers'

type ModalUserGroupsAccessNameCellProps = {
	row: UserGroupScopeItem
}

const ModalUserGroupsAccessNameCell = ({
	row: { label, role },
}: ModalUserGroupsAccessNameCellProps) => {
	return (
		<div>
			<div className="font-medium">{label}</div>
			{role && (
				<div className="text-sm text-gray-500">
					{addSpacesToPascalCase(role)}
				</div>
			)}
		</div>
	)
}

export default ModalUserGroupsAccessNameCell
